<gbc-page-error-handler [content]="content" [pageError$]="pageError$"></gbc-page-error-handler>
<ng-template #content>
  @if (pageInfo$ | async; as pageInfo) {
    <gbc-page-header [pageInfo]="pageInfo"></gbc-page-header>
  }
  @if (application$ | async; as application) {
    <gbc-page-container>
      @if (application.type === ApplicationType.UnspecifiedLoad) {
        <app-unspecified-load-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-unspecified-load-dashboard>
      }
      @if (application.type === ApplicationType.MixingLoop || application.type === ApplicationType.MixingloopUnspecifiedLoadSystem) {
        <app-mixing-loop-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-mixing-loop-dashboard>
      }
      @if (application.type === ApplicationType.HeatExchanger) {
        <app-heat-exchanger-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-heat-exchanger-dashboard>
      }
      @if (application.type === ApplicationType.HotWaterTank || application.type === ApplicationType.HotWaterTankStandAloneSystem) {
        <app-hot-water-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-hot-water-dashboard>
      }
      @if (application.type === ApplicationType.DistrictHeatingSupply) {
        <app-district-heating-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-district-heating-dashboard>
      }
      @if (application.type === ApplicationType.OutdoorTemperature) {
        <app-outdoor-temp-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-outdoor-temp-dashboard>
      }
      @if (application.type === ApplicationType.ColdWaterSupplySystem) {
        <app-cold-water-supply-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-cold-water-supply-dashboard>
      }
      @if (application.type === ApplicationType.CommercialHotWater) {
        <app-commercial-hot-water-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-commercial-hot-water-dashboard>
      }
      @if (application.type === ApplicationType.CommercialHotWaterStandalone) {
        <app-commercial-hot-water-dashboard-standalone
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-commercial-hot-water-dashboard-standalone>
      }
      @if (application.type === ApplicationType.HotWaterPump || application.type === ApplicationType.ColdWaterPump) {
        <app-pump-system-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-pump-system-dashboard>
      }
      @if (application.type === ApplicationType.Boiler) {
        <app-boiler-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-boiler-dashboard>
      }
      @if (application.type === ApplicationType.TwoStrokeHeatExchangerHotWaterSystem) {
        <app-two-stroke-heat-exchanger-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-two-stroke-heat-exchanger-dashboard>
      }
      @if (application.type === ApplicationType.BufferTank) {
        <app-buffer-tank-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-buffer-tank-dashboard>
      }
      @if (application.type === ApplicationType.PumpStandalone) {
        <app-pump-standalone-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-pump-standalone-dashboard>
      }
      @if (application.type === ApplicationType.PressureSensorSystem) {
        <app-pressure-system-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-pressure-system-dashboard>
      }
      @if (application.type === ApplicationType.IndirectDistrictHeatingSupplySystem) {
        <app-indirect-district-heating-supply-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-indirect-district-heating-supply-dashboard>
      }
      @if (application.type === ApplicationType.CascadeTankSystem) {
        <app-cascade-tank-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-cascade-tank-dashboard>
      }
      @if (application.type === ApplicationType.CascadeBufferTankChargingSystem) {
        <app-cascade-buffer-tank-charging-system-dashboard
          [schematic$]="schematic$"
          [dataPoints$]="dataPoints$"
          [application]="application"
          [installation$]="installation$"
          [alarm$]="alarm$">
        </app-cascade-buffer-tank-charging-system-dashboard>
      }
      @if (application.type === ApplicationType.Mixit && (isMixitPremium$ | async)) {
        <app-mixit-premium-dashboard
          [installation$]="installation$"
          [schematic$]="schematic$"
          [application$]="application$"
          [dataPoints$]="dataPoints$"
          [alarm$]="alarm$"
        ></app-mixit-premium-dashboard>
      }
      @if (application.type === ApplicationType.Mixit && ((isMixitPremium$ | async) === false)) {
        <app-mixit-freemium-dashboard
          [installation$]="installation$"
          [schematic$]="schematic$"
          [application$]="application$"
          [dataPoints$]="dataPoints$"
          [alarm$]="alarm$"
        ></app-mixit-freemium-dashboard>
      }
    </gbc-page-container>
  }
</ng-template>
